export const SOCKET_URL = "wss://demo-socket.ened.cloud"
//export const SOCKET_URL = "ws://localhost:443"
export const TEAM_NUMBER_SIZE = "15em"
